module.exports = __webpack_public_path__ + "media/images/efriends_logo-2388b660821dfe66630a041742927bb0.jpg";